import * as React from 'react'

const NavigationClose = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.717 3.284a.967.967 0 00-1.37 0L12 10.631 4.653 3.284a.967.967 0 10-1.369 1.37L10.631 12l-7.347 7.347a.967.967 0 101.37 1.37L12 13.37l7.347 7.347a.97.97 0 001.37-1.37L13.37 12l7.347-7.347a.97.97 0 000-1.369z" />
  </svg>
)

export default NavigationClose
